// MicrofinanceCompanyRegistration.jsx
import React from "react";

export default function MicrofinanceCompanyRegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Microfinance Company
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Microfinance Company Registration in India
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks provides structured support for Microfinance
            Company Registration, helping promoters align their business model
            with applicable financial and corporate regulations.
          </p>
          <p className="text-gray-700">
            From planning the legal structure and capital to preparing
            documentation and handling filings, the process is managed in an
            organized manner so you can focus on building and scaling your
            microfinance operations.
          </p>
        </div>

        {/* Right: Image (square style like others) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/4968391/pexels-photo-4968391.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Discussion on microfinance company registration"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for Microfinance Company Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks helps promoters collate, verify, and arrange
              the key records necessary for microfinance company setup, reducing
              errors during review and approval.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  KYC documents of directors and key promoters (PAN, identity,
                  and address proof).
                </li>
                <li>
                  Detailed business plan outlining proposed microfinance
                  activities, target segment, and operational model.
                </li>
                <li>
                  Proof of registered office address (rent agreement or
                  ownership proof, latest utility bill, and NOC from owner, if
                  applicable).
                </li>
                <li>
                  Capital and shareholding details along with supporting
                  financial information, where required.
                </li>
                <li>
                  Passport-size photographs and contact details of directors and
                  key managerial persons.
                </li>
                <li>
                  Any additional declarations, undertakings, or approvals
                  required under applicable financial regulations.
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm offers focused assistance for microfinance ventures,
              blending regulatory awareness with practical understanding of
              lending-focused business operations.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Financial Regulatory Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Guidance on applicable regulatory requirements and norms for
                  microfinance activities, helping structure operations within
                  the permitted framework.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Compliance-Focused Approach
                </h3>
                <p className="text-gray-700 text-sm">
                  Emphasis on accurate documentation, clear records, and
                  structured filings to minimize compliance gaps and review
                  issues.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Reliable Advisory Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Consistent advisory support throughout planning, registration,
                  and early operations, offering a dependable professional
                  partner for your microfinance venture.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
